var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("q-page", { attrs: { padding: "" } }, [
    _c(
      "div",
      { staticClass: "q-display-1 q-mb-md text-secondary" },
      [
        _c("q-icon", {
          staticClass: "q-mb-sm",
          attrs: { name: "fas fa-chalkboard-teacher" }
        }),
        _vm._v(" " + _vm._s(_vm.$t("planned_vacancies")) + "\n    ")
      ],
      1
    ),
    _c("div", { staticClass: "row gutter-sm" }, [
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-12" },
        [
          _c(
            "q-input",
            {
              attrs: {
                "float-label": _vm.$t("headquarter"),
                error: _vm.$v.company_branch_company.$error,
                filter: "",
                "autofocus-filter": "",
                clearable: "",
                disable: _vm.disableEditPlannedVacancies
              },
              on: {
                input: _vm.$v.company_branch_company.$touch,
                clear: _vm.removeHeadquarter
              },
              model: {
                value: _vm.company_branch_company_name,
                callback: function($$v) {
                  _vm.company_branch_company_name = $$v
                },
                expression: "company_branch_company_name"
              }
            },
            [
              _c("q-autocomplete", {
                attrs: { "min-characters": 1, "max-results": 100 },
                on: {
                  search: _vm.fetchHeadquarters,
                  selected: _vm.selectHeadquarter
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-12" },
        [
          _c("q-select", {
            attrs: {
              options: _vm.branches,
              "float-label": _vm.$t("branch"),
              error: _vm.$v.company_branch.$error,
              disable: _vm.disableEditPlannedVacancies || _vm.disableEdit
            },
            on: { input: _vm.selectBranch },
            model: {
              value: _vm.company_branch,
              callback: function($$v) {
                _vm.company_branch = $$v
              },
              expression: "company_branch"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-12" },
        [
          _c("q-input", {
            attrs: { "float-label": _vm.$t("fantasy_name"), disable: "" },
            model: {
              value: _vm.fantasy,
              callback: function($$v) {
                _vm.fantasy = $$v
              },
              expression: "fantasy"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-6" },
        [
          _c("q-input", {
            attrs: { "float-label": _vm.$t("store_document"), disable: "" },
            model: {
              value: _vm.company_branch_document,
              callback: function($$v) {
                _vm.company_branch_document = $$v
              },
              expression: "company_branch_document"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-6" },
        [
          _c("q-input", {
            attrs: { "float-label": _vm.$t("register_number"), disable: "" },
            model: {
              value: _vm.register,
              callback: function($$v) {
                _vm.register = $$v
              },
              expression: "register"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-12" },
        [
          _c(
            "q-input",
            {
              attrs: {
                "float-label": _vm.$t("course_catalog_code"),
                error: _vm.$v.presential_event_catalog.$error,
                filter: "",
                "autofocus-filter": "",
                clearable: "",
                disable: _vm.disableEditPlannedVacancies || _vm.disableEdit
              },
              on: {
                input: _vm.$v.presential_event_catalog.$touch,
                clear: _vm.removeCatalogCode
              },
              model: {
                value: _vm.presential_event_catalog_code,
                callback: function($$v) {
                  _vm.presential_event_catalog_code = $$v
                },
                expression: "presential_event_catalog_code"
              }
            },
            [
              _c("q-autocomplete", {
                attrs: { "min-characters": 1, "max-results": 100 },
                on: {
                  search: _vm.fetchCatalogCodes,
                  selected: _vm.selectCatalogCode
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-12" },
        [
          _c("q-input", {
            attrs: { "float-label": _vm.$t("course_name"), disable: "" },
            model: {
              value: _vm.presential_event_catalog_title,
              callback: function($$v) {
                _vm.presential_event_catalog_title = $$v
              },
              expression: "presential_event_catalog_title"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-6" },
        [
          _c("q-input", {
            attrs: {
              "float-label": _vm.$t("total_vacancies"),
              error: _vm.$v.qty_available_seats.$error,
              disable: _vm.disableEditPlannedVacancies
            },
            on: { input: _vm.$v.qty_available_seats.$touch },
            model: {
              value: _vm.qty_available_seats,
              callback: function($$v) {
                _vm.qty_available_seats = $$v
              },
              expression: "qty_available_seats"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-6" },
        [
          _c("q-input", {
            attrs: { "float-label": _vm.$t("filled_vacancies"), disable: "" },
            model: {
              value: _vm.qty_filled_seats,
              callback: function($$v) {
                _vm.qty_filled_seats = $$v
              },
              expression: "qty_filled_seats"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-12" },
        [
          _c(
            "q-field",
            {
              attrs: {
                helper: _vm.$t(
                  "the_quarter_must_be_filled_in_the_quarter_year_model_the_quarter_being_to_example"
                )
              }
            },
            [
              _c("q-input", {
                attrs: {
                  "float-label": _vm.$t("quarter"),
                  error: _vm.$v.year_quarter.$error,
                  disable: _vm.disableEditPlannedVacancies || _vm.disableEdit
                },
                on: { input: _vm.$v.year_quarter.$touch },
                model: {
                  value: _vm.year_quarter,
                  callback: function($$v) {
                    _vm.year_quarter = $$v
                  },
                  expression: "year_quarter"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ]),
    _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("cancel") },
        [
          _c("q-btn", {
            staticClass: "full-width",
            attrs: {
              color: "tertiary",
              label: _vm.$t("back"),
              icon: "fas fa-chevron-left"
            },
            on: {
              click: function($event) {
                return _vm.$router.push({ name: "planned_vacancies" })
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("save") },
        [
          _c("q-btn", {
            staticClass: "full-width",
            attrs: {
              color: "secondary",
              label: _vm.$t("save"),
              icon: "far fa-save",
              disable: _vm.disableEditPlannedVacancies
            },
            on: {
              click: function($event) {
                return _vm.saveData()
              }
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }